<div *ngIf="loading" class="spinnerWrapper">
  <gcv-spinner-icon></gcv-spinner-icon>
</div>
<div [hidden]="loading" class="canvasWrapper">
  <canvas #chartCanvas></canvas>
</div>
